import type { ComponentType } from 'react';

const componentLoader = (
  lazyComponent: () => Promise<{ default: ComponentType<unknown> }>,
  retriesLeft = 5,
  interval = 1000
): Promise<{ default: React.ComponentType<any> }> =>
  new Promise((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch((error: Error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            reject(error);

            return;
          }
          componentLoader(lazyComponent, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });

export default componentLoader;
